import React, { Component } from 'react'
import { Route, Redirect } from 'react-router-dom'
import ChatList from '../../containers/ChatList'
import ChatRoom from '../../containers/ChatRoom'
import './index.css'

class App extends Component {
  render() {
    return (
      <div className="App">
        <h1>Chats</h1>
        <Redirect from="/" to="/chats" />
        <Route
          exact
          path="/chats"
          component={ChatList}
        />
        <Route
          path="/chats/:chatId"
          component={ChatRoom}
        />
      </div>
    )
  }
}

export default App
